module.exports = __webpack_public_path__ + "img/b9b3c69215fe922ae465ef306c456107.png";